// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useTeamMembersPostType = () => {
  const { teamMembers } = useStaticQuery(graphql`
    query TeamMembers {
      teamMembers: allWpTeamMember(sort: { menuOrder: ASC }) {
        nodes {
          title
          menuOrder
          teamMembers {
            bio
            jobTitle
            linkedinProfileUrl
            instagramProfileUrl
            facebookProfileUrl
            britishPsychologicalSocietyUrl
            twitterProfileUrl
          }
          featuredImage {
            node {
              gatsbyImage(width: 400)
              altText
              mediaDisplayOptions {
                filter
              }
            }
          }
          teamOffices {
            nodes {
              name
              slug
              databaseId
            }
          }
        }
      }
    }
  `);

  // TO-DO: Fix reordering plugin
  // menuOrder 0 currently comes through to GQL as null and therefore the first post comes through as last without this additional logic
  const nodes = teamMembers?.nodes;

  const newNodes = nodes.filter((node) => node?.menuOrder !== null);

  const nullOrder = nodes.filter((node) => node?.menuOrder == null);

  if (nullOrder.length) newNodes.unshift(nullOrder.pop());

  // TO-DO: Sort via GQL or WordPress layer
  // Sorts TeamOffices by database IDs
  newNodes.forEach((node) => {
    node.teamOffices.nodes.sort((a, b) => a.databaseId - b.databaseId);
  });

  return newNodes;
};

export default useTeamMembersPostType;
